/**
 * Formats a number to a specified number of decimal places and returns it as a number
 * @param value - The number to format
 * @param decimalPlaces - Number of decimal places (default: 2)
 * @returns The formatted number
 */
export const formatNumber = (value: number, decimalPlaces: number = 2): number => {
  if (value === null || value === undefined || isNaN(value)) {
    return 0;
  }
  return parseFloat(Number(value).toFixed(decimalPlaces));
};

/**
 * Formats a number to 2 decimal places and returns it as a number
 * @param value - The number to format
 * @returns The formatted number with 2 decimal places
 */
export const formatCurrency = (value: number): number => {
  return formatNumber(value, 2);
};

/**
 * Formats a percentage value to 2 decimal places and returns it as a number
 * @param value - The percentage value to format
 * @returns The formatted percentage number with 2 decimal places
 */
export const formatPercentage = (value: number): number => {
  return formatNumber(value, 2);
}; 